import clsx from 'clsx';
import { type ReactNode, useState } from 'react';

/** `background`, not `backgroundColor`, so a caller may pass a composite. */
export function Swatch({ color, hollow }: { color: string; hollow?: boolean }) {
  return (
    <span
      aria-hidden
      className={clsx(
        'size-2.5 shrink-0 rounded-mark',
        hollow ? 'ring-2 ring-inset' : 'ring-1 ring-ink/20',
      )}
      style={hollow ? { color } : { background: color }}
    />
  );
}

export function Avatar({
  picture,
  name,
  className,
}: {
  picture: string | null;
  name: string;
  className: string;
}) {
  // Holds the URL that failed, not a flag, so a new picture URL gets a fresh try.
  const [broken, setBroken] = useState<string | null>(null);
  return picture !== null && picture !== broken ? (
    <img
      src={picture}
      alt=""
      onError={() => setBroken(picture)}
      className={clsx('shrink-0 rounded-full object-cover', className)}
      referrerPolicy="no-referrer"
    />
  ) : (
    <span
      aria-hidden
      className={clsx(
        'grid shrink-0 place-items-center rounded-full bg-surface-raised font-medium text-ink-muted',
        className,
      )}
    >
      {name.slice(0, 1).toUpperCase()}
    </span>
  );
}

export function Count({ n, className }: { n: number; className?: string }) {
  if (n <= 0) return null;
  return (
    <span
      className={clsx(
        'tnum absolute min-w-4 rounded-full bg-accent px-1 text-center text-3xs leading-4 font-semibold text-canvas',
        className,
      )}
    >
      {n > 99 ? '99+' : n}
    </span>
  );
}

export function Chip({ tone, children }: { tone: string; children: ReactNode }) {
  return (
    <span className={clsx('rounded-tag px-2 py-0.5 text-xs font-medium whitespace-nowrap', tone)}>
      {children}
    </span>
  );
}
